import { render, staticRenderFns } from "./CalendarReminderItems.vue?vue&type=template&id=17fbbd22&"
import script from "./CalendarReminderItems.vue?vue&type=script&lang=js&"
export * from "./CalendarReminderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports